export const CITIZENSHIP_KEY_POINTS = [
  "conferral, descent, evidence와 resumption 등 신청 유형을 먼저 구분하세요.",
  "Residence Calculator 결과는 estimate이며 실제 평가는 신청 시점 Department 기록을 기준으로 합니다.",
  "lawful·permanent residence와 해외 체류 한도를 모두 확인하세요.",
  "passport·name change·birth·travel·visa와 character 정보가 일치해야 합니다.",
  "test 또는 interview 대상과 identity documents를 appointment notice에서 확인하세요.",
  "시험 준비는 Home Affairs의 Our Common Bond를 기준으로 하세요.",
  "processing time은 참고치이며 개인별 완료시점을 보장하지 않습니다.",
  "pledge가 필요한 사람은 ceremony를 완료해야 시민이 됩니다.",
] as const;

export const CITIZENSHIP_SECTIONS = [
  {
    id: "choose-pathway",
    title: "1. 정확한 citizenship pathway와 기본 eligibility를 확인하세요",
    body: [
      "permanent resident conferral인지, descent·evidence·resumption 또는 특별 경로인지 Home Affairs에서 확인하세요. permanent visa가 있다고 자동으로 eligibility가 생기지는 않습니다.",
      "age, residence, identity, character, test·interview와 pledge requirement가 상황에 따라 다릅니다. SCV, defence service, special residence, 과거 citizenship·criminal·migration issue가 있으면 current exemption과 specialist advice를 확인하세요.",
    ],
    checklist: ["current passport", "permanent visa·SCV", "application type", "identity·character issues", "citizenship history", "special residence 가능성"],
    sourceIds: ["citizenship-source-conferral", "citizenship-source-residence"],
  },
  {
    id: "calculate-residence",
    title: "2. residence와 모든 출입국 기록을 신청일 기준으로 계산하세요",
    body: [
      "현재 일반 conferral rule은 신청 직전 4년간 valid visa로 거주하고 마지막 12개월은 permanent visa 또는 해당 SCV를 보유하며, 지난 4년과 마지막 12개월의 해외 체류가 current limit 안에 있어야 한다고 안내합니다.",
      "Calculator에 lawful residence, permanent residence, intended lodgement와 모든 travel dates를 입력하세요. 결과는 guide only이며 자동 전송되지 않습니다. 기록이 불완전하면 movement records를 요청하고 신청 전 future travel도 반영하세요.",
    ],
    checklist: ["lawful residence start", "permanent residence start", "lodgement date", "최근 4년 travel", "future travel", "movement records", "exemption"],
    sourceIds: ["citizenship-source-residence", "citizenship-source-movement"],
  },
  {
    id: "prepare-and-apply",
    title: "3. identity·character·travel 자료를 정리해 완전한 신청을 제출하세요",
    body: [
      "current checklist에서 passport, birth·identity, photograph, name change, permanent residence, travel와 family documents를 확인하세요. 이름·생년월일·passport와 address history를 대조하고 accepted translation requirement를 확인하세요.",
      "offence·court·police·military와 immigration 정보를 사실대로 답하고 requested evidence를 준비하세요. ImmiAccount submission, payment와 receipt를 확인하고 업로드 자료 사본을 보관하세요. 완전한 신청도 승인이나 일정 단축을 보장하지 않습니다.",
    ],
    checklist: ["passport·birth·photo ID", "name change·family", "address·travel·visa history", "character information", "translations", "receipt·copies"],
    sourceIds: ["citizenship-source-conferral", "citizenship-source-movement", "citizenship-source-processing"],
  },
  {
    id: "test-and-interview",
    title: "4. appointment notice에 맞춰 test 또는 interview를 준비하세요",
    body: [
      "대부분의 conferral applicant 중 해당 연령대는 citizenship test appointment를 받고, 다른 신청자는 interview만 진행할 수 있습니다. notice에서 날짜·장소·identity documents와 reschedule 방법을 확인하세요.",
      "시험은 English와 Australia, citizenship responsibilities·privileges와 values를 평가합니다. Home Affairs는 Our Common Bond가 필요한 공식 자료라고 안내하며 외부 유료 course·app을 endorse하지 않습니다.",
    ],
    checklist: ["appointment notice", "original identity documents", "Our Common Bond", "official practice", "assistance request", "reschedule procedure"],
    sourceIds: ["citizenship-source-test", "citizenship-source-common-bond"],
  },
  {
    id: "decision-and-ceremony",
    title: "5. decision·ceremony invitation과 pledge 완료를 관리하세요",
    body: [
      "ImmiAccount와 correspondence에서 추가자료·test·decision을 확인하고 passport, address, travel 또는 family circumstances가 바뀌면 current procedure로 update하세요. processing time은 monthly guide이며 접수 순서대로 항상 finalise되지는 않습니다.",
      "approval이 항상 취득 완료를 의미하지는 않습니다. pledge가 필요한 대부분의 applicant는 invitation을 받고 ceremony에서 pledge를 한 뒤 시민이 됩니다. invitation의 date·identity requirements를 따르고 참석 문제는 organiser의 current path로 문의하세요.",
    ],
    checklist: ["ImmiAccount messages", "request deadline", "decision notice", "ceremony invitation", "identity documents", "pledge", "certificate"],
    sourceIds: ["citizenship-source-processing", "citizenship-source-ceremony"],
  },
] as const;

export const CITIZENSHIP_ADDITIONAL_CHECKS = [
  "lodging 직전 pathway, eligibility, fee와 document checklist를 확인하세요.",
  "travel·SCV·special residence·criminal or migration history가 있으면 specialist review를 받으세요.",
  "calculator와 movement records를 실제 visa history와 대조하세요.",
  "appointment·additional request·ceremony deadline을 직접 관리하세요.",
] as const;
